import { macroSearchText } from './filterMacros';

const categoryFor = (macro, categories) => {
  const searchable = macroSearchText(macro);

  return (
    categories.find(category =>
      category.keywords.some(keyword =>
        searchable.includes(keyword.toLocaleLowerCase())
      )
    ) ?? categories.at(-1)
  );
};

export const groupMacros = (macros, categories) => {
  const groups = new Map();

  macros.forEach(macro => {
    const category = categoryFor(macro, categories);
    const prefix = category.keywords[0];
    const displayName = macro.name.startsWith(prefix)
      ? macro.name.slice(prefix.length)
      : macro.name;

    if (!groups.has(category.key)) {
      groups.set(category.key, { ...category, macros: [] });
    }

    groups.get(category.key).macros.push({ ...macro, name: displayName });
  });

  groups.forEach(group => {
    const order = new Map(group.order.map((name, index) => [name, index]));
    group.macros.sort(
      (a, b) =>
        (order.get(a.name) ?? Number.MAX_SAFE_INTEGER) -
        (order.get(b.name) ?? Number.MAX_SAFE_INTEGER)
    );
  });

  return categories.map(category => groups.get(category.key)).filter(Boolean);
};
